import Coschedule from "./Assets/Projects/coschedule.PNG";
import bathandwash from "./Assets/Projects/bathandwash.png";
import ideacart from "./Assets/Projects/ideacart.PNG";
import onestop from "./Assets/Projects/onestop.PNG";
import stackoverflow from "./Assets/Projects/stackoverflow.png";

export const PROJECTS = [
  {
    image: Coschedule,
    name: "CoSchedule",
    technologyUsed: "HTML, CSS, JavaScript",
    description:
      "Provide marketers with tools & training that are uniquely helpful, fun to use, & consistently punch above their weight.",
    url: "https://co-schedule-clone-qk3n600j0-jubershaikh2307.vercel.app/",
    github: "https://github.com/Jubershaikh2307/selective-drawer-3054",
  },
  {
    image: ideacart,
    name: "Idea Cart",
    technologyUsed: "HTML , CSS , JavaScript ,ES6",
    description:
      "Ideakart is a site that gives u an idea about the book you want to buy.",
    url: "https://fabulous-vest-203.vercel.app/",
    github: "https://github.com/abhiamber/fabulous-vest-203-",
  },
  {
    image: onestop,
    name: "OneStop",
    technologyUsed: "React, Javascript, Redux , BootStrap , Chakra UI",
    description:
      "Team collaboration mobile app and online services like slack Message people and groups without sharing phone numbers, communicate with managers and staff all in one place. and discuss or assign tasks to get stuff done",
    url: "https://one-stop-dusky.vercel.app/",
    github: "https://github.com/kartikkunwar/bizarre-fog-8734",
  },
  {
    image: bathandwash,
    name: "Bath & Body Works",
    technologyUsed: "React, Javascript, Redux , BootStrap , Chakra UI",
    description:
      "Bath & Body Works brings you Buy 3 Get 1 on your favorite Body Care products. Shop from the most loved fragrances of mists, lotions, creams, & much more. Quick & Secure Checkout. 100% Original. Easy Returns. Secured Payment. Limited Period Offer. Reasonable Price.",
    url: "https://mybathnbody.vercel.app/",
    github: "https://github.com/Khalidshah12/somber-shape-4789",
  },
  {
    image: stackoverflow,
    name: "StackOverFlow Clone",
    technologyUsed:
      "React, Javascript, Redux , BootStrap , Chakra UI, Tailwind, HTML && CSS",
    description:
      "This web application is designed to provide a platform for users to ask questions, provide answers, and share knowledge on a variety of topics, much like the popular Stack Overflow platform.",
    url: "https://frontend-ena4uefdq-jubershaikh2307.vercel.app/",
    github: "https://github.com/Jubershaikh2307/stackoverflow-clone",
  },
];

export const SKILLS = [
  { name: "ReactJs", initialRating: 4 },
  { name: "React-Native", initialRating: 4 },
  { name: "JavaScript", initialRating: 4 },
  { name: "Redux", initialRating: 4 },
  { name: "Nodejs", initialRating: 3 },
  { name: "Html", initialRating: 4 },
  { name: "CSS", initialRating: 4 },
  { name: "Unit-Testing(Jest)", initialRating: 3 },
  { name: "TypeScript", initialRating: 4 },
  { name: "Graphql", initialRating: 4 },
  { name: "Apollo", initialRating: 4 },
  { name: "Material UI", initialRating: 4 },
  { name: "Nodejs", initialRating: 4 },
];

export const TOOLS = [
  "Visual Studio Code",
  "Git",
  "Npm (Node Package Manager)",
  "Linux",
  "Heroku",
  "Postman",
];
